/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]   .form-input-viewer_10[_ngcontent-%COMP%]{min-height:48px}[_nghost-%COMP%]   .form-input-viewer_8[_ngcontent-%COMP%]{width:100%}@media (max-width:1279px){[_nghost-%COMP%]   form-input-viewer[_ngcontent-%COMP%]{width:100%!important;display:block}}"];
export { styles as styles };
